import excel from './iconnew.xlsx'

export default excel